import { render } from "./ManageAssets.vue?vue&type=template&id=4dd88e76&scoped=true"
import script from "./ManageAssets.vue?vue&type=script&lang=js"
export * from "./ManageAssets.vue?vue&type=script&lang=js"

import "./ManageAssets.vue?vue&type=style&index=0&id=4dd88e76&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd88e76"]])

export default __exports__